import { setContext } from '@apollo/client/link/context';

import { base64ToString } from '@/utils/stringUtils';
import history from '@/utils/history';
import { clearAuthStorage } from '@/utils/authStorage';

const TIME_TO_LIVE_MS = 1000 * 60 * 60;

const checkForTokenExpiration = () => {
  const tokenCreatedAt: string = localStorage.getItem('tokenCreatedAt') || '';
  if (!tokenCreatedAt) {
    clearAuthStorage();
    return;
  }
  const tokenCreatedAtMs = parseInt(base64ToString(tokenCreatedAt), 10);
  if (Number.isNaN(tokenCreatedAtMs)) {
    clearAuthStorage();
    history.push('/login');
    return;
  }
  const tokenExpiration = new Date(tokenCreatedAtMs + TIME_TO_LIVE_MS);
  if (tokenExpiration <= new Date()) {
    clearAuthStorage();
    history.push('/login');
  }
};

export const withTokenLink = setContext((_, previousContext) => {
  // Skip legacy JWT expiration checks for Supabase-authenticated requests.
  const existingAuth: string = previousContext.headers?.Authorization || previousContext.headers?.authorization || '';
  if (existingAuth.startsWith('Bearer ')) {
    return { headers: { ...(previousContext.headers || {}) } };
  }

  checkForTokenExpiration();

  const token = previousContext.token || localStorage.getItem('token');
  return {
    headers: {
      ...(previousContext.headers || {}),
      authorization: token ? `JWT ${token}` : '',
    },
  };
});
